import mutations from './eesztPuphax.mutations'
import actions from './eesztPuphax.actions'
import getters from './eesztPuphax.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
